import { render } from "./LicensePlate.vue?vue&type=template&id=82425a0c"
import script from "./LicensePlate.vue?vue&type=script&lang=js"
export * from "./LicensePlate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__